import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../utils/rel';

class NewsSiderTitle extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        type: PropTypes.number,
        children: PropTypes.object,
    };

    render() {
        const { content, type, children } = this.props;
        const sep = type === 0 ? '/' : '·';

        return (
            <div className={styles.title}>
                {content.map((item, index) => (
                    <React.Fragment key={index}>
                        {item.url ? (
                            <a href={item.url} target="_blank" rel={rel}>
                                {item.title}
                            </a>
                        ) : (
                            <a>{item.title}</a>
                        )}
                        {index !== content.length - 1 ? sep : ''}
                    </React.Fragment>
                ))}
                {children}
            </div>
        );
    }
}

export default errorBoundary(NewsSiderTitle);
